<template>
    <div class="footer">
        <div class="footer_div">
            <div class="logo_other_site_div">
                <!--<img class="logo_img" src="https://static.shiyanlou.com/img/logo-white.svg">-->
                <div class="chat_tools_div">
                    <div class="wechat_qr_div">
                        <a href="javascript:;">
                            <i class="fab fa-weixin"></i>
                        </a>
                    </div>
                    <div class="weibo_div">
                        <a href="javascript:;">
                            <i class="fab fa-weibo"></i>
                        </a>
                    </div>
                </div>
                <p class="logo_other_site_description_p">全域职业发展与佑佐成长</p>
            </div>
            <div class="category_div company_description">
                <p class="main_category">公司</p>
                <a href="http://www.ujoy.cn" class="single_item_a">管理咨询</a>
                <a href="http://px.ujoy.cn" class="single_item_a">教育培训</a>
                <a href="http://info.ujoy.cn" class="single_item_a">信息软件</a>
            </div>
            <div class="category_div cooperation_div">
                <p class="main_category">合作</p>
                <a href="" class="single_item_a">培训合作</a>
                <a href="" class="single_item_a">企业合作</a>
                <a href="" class="single_item_a">高校合作</a>
            </div>
            <div class="category_div service_div">
                <p class="main_category">服务</p>
                <a href="" class="single_item_a">会员服务</a>
                <a href="" class="single_item_a">课程体系</a>
                <a href="" class="single_item_a">技术支持</a>
            </div>
            <div class="category_div learning_path_div">
                <p class="main_category">关于</p>
                <a href="" class="single_item_a">系统简介</a>
                <a href="" class="single_item_a">关于佑佐</a>
                <a href="" class="single_item_a">加入佑佐</a>
            </div>
        </div>
        <div class="site_information">
            HR成长之路 · 佑佐全域职业规划系统 · 南京佑佐信息资讯有限公司
        </div>
    </div>
</template>

<script type="text/javascript">
export default {

}
</script>

<style type="text/css" scoped>
.footer {
    background: url(/static/img/bg_footer_1.jpg);
    padding-top: 20px;
}

.footer_div {
    width: 1170px;
    margin: 0 auto;
    padding: 0 15px;
    display: flex;
    /*position: relative;*/
}

/* */
.logo_other_site_div {
    width: 33.333333%;
}

.logo_img {
    height: auto;
    padding: 15px;
}

.logo_other_site_description_p {
    margin: 0 0 0 15px;
    color: #6699CC;
    font-size: 22px;
    top: 30px;
    position: relative;
}

/* */
.main_category {
    font-size: 18px;
    margin-bottom: 10px;
    color: #eee;
}

.category_div {
    width: 16.66666%;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
}

.single_item_a {
    display: inline-block;
    color: #999;
    font-size: 14px;
    margin-bottom: 3px;
}

.single_item_a:hover {
    color: #fff;
}

/* 网站信息部分，备案等 */

.site_information {
    background: #171919;
    box-sizing: border-box;
    margin-top: 20px;
    height: 50px;
    text-align: center;
    color: #ccc;
    line-height: 50px;
}

/* 微信和微博 */
.chat_tools_div {
    display: flex;
}

.wechat_qr_div, .weibo_div {
    width: 30px;
    height: 30px;
    font-size: 16px;
    background: #636469;
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    margin: 0 15px;
}

.fa-weixin {
    color: #36bd4c;
}

.fa-weibo {
    color: #ee4451;
}

</style>
